import React from 'react';
import { Badge } from '../../../components/app2';

/**
 * Estado de una suscripción (rediseño jul-2026).
 * Traduce los tonos que ya usaban las pantallas de billing a los del sistema,
 * para que un "activa" o un "periodo de gracia" se vean igual en toda la app.
 */

const TONE = {
  success: { tone: 'ok', icon: 'check_circle' },
  info: { tone: 'brand', icon: 'info' },
  warning: { tone: 'warn', icon: 'warning' },
  error: { tone: 'danger', icon: 'error' },
  muted: { tone: 'neutral', icon: 'radio_button_unchecked' },
};

const StatusBadge = ({ tone = 'muted', label, icon, className = '' }) => {
  const t = TONE[tone] || TONE.muted;
  return (
    <Badge tone={t.tone} icon={icon || t.icon} className={className}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
